<fui-chrome-control-link (click)="open()" [title]="'wbo.chrome.button.localisation'">
    <wbo-localisation-indicator [isLocalised]="authService.isRestrictedLocalisation" [height]="16" [width]="16"></wbo-localisation-indicator>
</fui-chrome-control-link>
